import { PublicEventNames } from "./PublicEventNames";

export type MessageEventData = {
  name: PublicEventNames;
  extraData?: Record<string, string>;
};

const postMessageEvent = (event: Record<string, string>): void => {
  window.parent.postMessage(event, "*");
  if (window.opener) window.opener.postMessage(event, "*");
};

export const usePostMessageEvent = () => {
  const wrappedPostMessageEvent = (event: MessageEventData): void => {
    const { name, extraData } = event;
    const payload = { name, ...extraData };
    postMessageEvent(payload);
  };

  return {
    postMessageEvent: wrappedPostMessageEvent,
  };
};
